import React, {memo} from 'react';
import classNames from "classnames";
import PropTypes from 'prop-types';

const PropertiesColumn = memo(({product, projectState, propertyName}) => (
  <td className="pt-4">
    <p className={classNames({
      'text-center': true,
      'ms-4': true,
      'text-gray': !product.status
    })}>
      {product.properties && product.properties[propertyName] ? product.properties[propertyName] : ''}
    </p>
  </td>
));

PropertiesColumn.propTypes = {
  product: PropTypes.object.isRequired,
  projectState: PropTypes.object.isRequired,
  propertyName: PropTypes.string.isRequired
};

export default PropertiesColumn;
